<template>
  <div
    class="baseButton"
    :class="{
      buttonLight: this.mode == 'light',
      buttonDark: this.mode == 'dark',
    }"
  >
    <!-- <img :src="imgSrc" width="15" height="15" :color="colorHex" /> -->
    <Icon :icon="icon" :hexCode="colorHex" :size="s" stroke="2" />
    <div v-if="text && icon" style="margin-right: 5px"></div>
    <div v-if="text" :class="{ textWithImg: this.img }">{{ text }}</div>
  </div>
</template>

<script>
import Icon from "../utilities/Icon.vue";

export default {
  name: "BaseButton",
  props: {
    text: String,
    icon: Function,
    icon_size: String,
    mode: {
      type: String,
      default: "light",
    },
  },
  components: {
    Icon,
  },
  data() {
    return {
      imgSrc: "@/assets/icons/" + this.img + ".vue",
      colorHex: this.mode == "light" ? "#000000" : "#ffffff",
      s: this.icon_size ? this.icon_size : "18",
    };
  },
  methods: {},
  setup() {
    return {};
  },
};
</script>

<style scoped>
.baseButton {
  border-radius: 7px;
  font-size: 14px;
  padding: 5px 7px;
  min-width: 14px;
  min-height: 18px;
  display: flex;
  margin: 2px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.buttonLight {
  border-bottom: thin solid #dadada;
  outline: thin solid #dadada;
  background: white;
}
.buttonLight:hover {
  background: #efefef;
}
.buttonLight:active {
  border-bottom: none;
  margin-top: 3px;
}
.buttonDark {
  border-bottom: thin solid #444444;
  outline: thin solid #444444;
  background: #212121;
  color: white;
}
.buttonDark:hover {
  background: #272727;
}
.buttonDark:active {
  border-bottom: none;
  margin-top: 3px;
}
.textWithImg {
  margin-left: 10px;
}
</style>
